module.exports = __webpack_public_path__ + "static/media/robo-bg.146b1ea9.mp4";